import { CssBaseline } from '@material-ui/core';

import {
  AppTheme,
  ExtensionDefinition,
  createExtension,
} from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';

import { IconMix, IconMoon } from '@spotify/confidence-core-react';

import './styles/app-styles.css';
import {
  EncoreDarkThemeProvider,
  EncoreLightThemeProvider,
} from './themes/encore';

const themeConfigs: AppTheme[] = [
  {
    id: 'encore-dark',
    title: 'Dark',
    variant: 'dark',
    icon: <IconMoon />,
    Provider: ({ children }) => (
      <EncoreDarkThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </EncoreDarkThemeProvider>
    ),
  },
  {
    id: 'encore-light',
    title: 'Light',
    variant: 'light',
    icon: <IconMix />,
    Provider: ({ children }) => (
      <EncoreLightThemeProvider>
        <CssBaseline>{children}</CssBaseline>
      </EncoreLightThemeProvider>
    ),
  },
];

const extensions: ExtensionDefinition[] = [];

// disabling the default themes from Backstage
for (const id of ['light', 'dark']) {
  if (!themeConfigs.some(theme => theme.id === id)) {
    extensions.push(
      createExtension({
        kind: 'theme',
        name: id,
        attachTo: { id: 'api:app/app-theme', input: 'themes' },
        disabled: true,
        output: [],
        factory: () => [],
      }),
    );
  }
}

extensions.push(
  ...themeConfigs.map(theme =>
    ThemeBlueprint.make({
      name: theme.id,
      params: { theme },
    }),
  ),
);

export const AppThemes = extensions;
